import React, { useEffect } from 'react';
import './ProductsPage.css';

const vehicleFallback =
  'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=900&q=80';

const dashcamFallback =
  'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=900&q=80';

const productsData = [
  {
    category: 'JC Dashcam Series',
    badge: 'Video Telematics & Dashcams',
    description:
      'Smart dashcam and video monitoring devices for live video, driver safety, incident recording, and fleet visibility.',
    products: [
      {
        model: 'JC181',
        name: 'JC181 Dashcam Device',
        image: '/dts-assets/products/jc181.png',
        fallback: dashcamFallback,
        short:
          'Compact dashcam device designed for vehicle video monitoring, driver visibility, and trip safety.',
        features: ['Video Monitoring', 'Trip Visibility', 'Event Review', 'Fleet Safety'],
      },
      {
        model: 'JC182',
        name: 'JC182 Dashcam Device',
        image: '/dts-assets/products/jc182.png',
        fallback: dashcamFallback,
        short:
          'Professional dashcam unit for better driver accountability, incident evidence, and road security.',
        features: ['Driver Safety', 'Incident Evidence', 'Route Video', 'Security Monitoring'],
      },
      {
        model: 'JC261',
        name: 'JC261 Dashcam Device',
        image: '/dts-assets/products/jc261.png',
        fallback: dashcamFallback,
        short:
          'Smart vehicle camera solution for fleet video monitoring, route recording, and driver safety support.',
        features: ['Live View', 'Video Recording', 'Event Alerts', 'Fleet Monitoring'],
      },
      {
        model: 'JC261P',
        name: 'JC261P Dashcam Device',
        image: '/dts-assets/products/jC261p.png',
        fallback: dashcamFallback,
        short:
          'Advanced dashcam device built for professional fleets needing strong visibility and reliable video records.',
        features: ['HD Video', 'Driver View', 'Event Recording', 'Remote Monitoring'],
      },
      {
        model: 'JC371',
        name: 'JC371 Fleet Dashcam',
        image: '/dts-assets/products/jc371.png',
        fallback: dashcamFallback,
        short:
          'Reliable fleet dashcam for road video evidence, driver behavior review, and remote monitoring.',
        features: ['Video Evidence', 'GPS Support', 'Driving Events', 'Remote Access'],
      },
      {
        model: 'JC400D',
        name: 'JC400D AI Dashcam',
        image: '/dts-assets/products/jc400d.png',
        fallback: dashcamFallback,
        short:
          'AI-powered dashcam solution for advanced driver safety, road event detection, and fleet protection.',
        features: ['AI Alerts', 'Road View', 'Driver Monitoring', 'Incident Records'],
      },
      {
        model: 'JC450',
        name: 'JC450 AI Dashcam',
        image: '/dts-assets/products/jc450.png',
        fallback: dashcamFallback,
        short:
          'Advanced AI dashcam solution for live video monitoring, safety alerts, and fleet security.',
        features: ['Live Video', 'AI Alerts', 'Driver View', 'Incident Recording'],
      },
    ],
  },
  {
    category: 'VG GPS Tracker Series',
    badge: 'Discreet GPS Tracking Devices',
    description:
      'Discreet GPS tracking devices built for solid performance, vehicle protection, ignition monitoring, alerts, and smart fleet control.',
    products: [
      {
        model: 'VG-03',
        name: 'VG-03 GPS Tracker',
        image: '/dts-assets/products/VG-03.png',
        fallback: vehicleFallback,
        short:
          'Discreet tracking device with solid performance for daily fleet monitoring, vehicle safety, and remote protection.',
        features: [
          'Ignition Detection',
          'Remote Power & Fuel Cutoff',
          'Multiple Alerts',
          'Driving Behavior Analysis',
          'Geo-Fence',
          'Auto Power Saving',
        ],
      },
    ],
  },
  {
    category: 'VL Vehicle Tracking Series',
    badge: 'GPS Tracking Devices',
    description:
      'Vehicle tracking devices for real-time location, route history, alerts, theft protection, and fleet control.',
    products: [
      {
        model: 'VL101G',
        name: 'VL101G GPS Tracker',
        image: '/dts-assets/products/VL101G.png',
        fallback: vehicleFallback,
        short:
          'Reliable GPS tracker for daily vehicle monitoring, live location, and basic fleet security.',
        features: ['Live Location', 'Route History', 'Ignition Alert', 'Vehicle Security'],
      },
      {
        model: 'VL103D',
        name: 'VL103D GPS Tracker',
        image: '/dts-assets/products/VL103D.png',
        fallback: vehicleFallback,
        short:
          'Dependable GPS tracking device for vehicle monitoring, route visibility, and trip activity records.',
        features: ['Live GPS', 'Trip Reports', 'Route Playback', 'Alerts'],
      },
      {
        model: 'VL103M',
        name: 'VL103M GPS Tracker',
        image: '/dts-assets/products/VL103M.png',
        fallback: vehicleFallback,
        short:
          'Advanced vehicle tracker for stronger monitoring, smart alerts, and fleet performance control.',
        features: ['Real-Time Tracking', 'Geo-Fence', 'Overspeed Alerts', 'Driver Behavior'],
      },
      {
        model: 'VL106',
        name: 'VL106 Vehicle Tracker',
        image: '/dts-assets/products/VL106.png',
        fallback: vehicleFallback,
        short:
          'Smart tracking device for vehicle security, route monitoring, and business fleet management.',
        features: ['Vehicle Tracking', 'Smart Alerts', 'History Logs', 'Security Support'],
      },
      {
        model: 'VL110C',
        name: 'VL110C Compact Tracker',
        image: '/dts-assets/products/VL110C.png',
        fallback: vehicleFallback,
        short:
          'Compact GPS tracker for reliable location monitoring, vehicle safety, and daily fleet control.',
        features: ['Compact Design', 'Location Alerts', 'Route Playback', 'Theft Protection'],
      },
      {
        model: 'VL111',
        name: 'VL111 Smart Tracker',
        image: '/dts-assets/products/VL111.png',
        fallback: vehicleFallback,
        short:
          'Smart vehicle tracker for consistent monitoring, better control, and detailed fleet reports.',
        features: ['Live Status', 'Smart Alerts', 'Fleet Reports', '24/7 Monitoring'],
      },
      {
        model: 'VL113',
        name: 'VL113 GPS Tracker',
        image: '/dts-assets/products/VL113.png',
        fallback: vehicleFallback,
        short:
          'Professional tracking device for vehicle visibility, movement alerts, and operational control.',
        features: ['GPS Tracking', 'Movement Alerts', 'Trip History', 'Fleet Visibility'],
      },
      {
        model: 'VL501',
        name: 'VL501 Tracking Device',
        image: '/dts-assets/products/VL501.png',
        fallback: vehicleFallback,
        short:
          'Fleet tracking hardware for real-time monitoring, reports, and improved vehicle security.',
        features: ['Live Monitoring', 'Reports', 'Alerts', 'Vehicle Control'],
      },
      {
        model: 'VL502(A)',
        name: 'VL502(A) Tracking Device',
        image: '/dts-assets/products/VL502%20(A).png',
        fallback: vehicleFallback,
        short:
          'Smart tracking device for vehicle monitoring, route history, and better fleet supervision.',
        features: ['Route History', 'Location Tracking', 'Alerts', 'Fleet Reports'],
      },
      {
        model: 'VL502',
        name: 'VL502 Tracking Device',
        image: '/dts-assets/products/VL502.png',
        fallback: vehicleFallback,
        short:
          'Vehicle tracking solution for real-time visibility, security alerts, and trip management.',
        features: ['Real-Time Visibility', 'Trip Logs', 'Security Alerts', 'Route Control'],
      },
      {
        model: 'VL505',
        name: 'VL505 GPS Tracker',
        image: '/dts-assets/products/VL505.png',
        fallback: vehicleFallback,
        short:
          'Advanced GPS tracking device for improved monitoring, fleet activity, and vehicle safety.',
        features: ['Fleet Activity', 'Live Tracking', 'Geo-Fence', 'Reports'],
      },
      {
        model: 'VL512',
        name: 'VL512 Tracking Device',
        image: '/dts-assets/products/VL512.png',
        fallback: vehicleFallback,
        short:
          'Reliable tracking hardware for business vehicles, security monitoring, and route visibility.',
        features: ['Business Tracking', 'Route Visibility', 'Alerts', 'Vehicle Safety'],
      },
      {
        model: 'VL802',
        name: 'VL802 GPS Tracker',
        image: '/dts-assets/products/VL802.png',
        fallback: vehicleFallback,
        short:
          'Fleet tracking device for live location, trip history, alerts, and better operational control.',
        features: ['Live Location', 'Trip History', 'Instant Alerts', 'Fleet Control'],
      },
      {
        model: 'VL808',
        name: 'VL808 OBD Tracker',
        image: '/dts-assets/products/VL808.png',
        fallback: vehicleFallback,
        short:
          'Easy plug-in OBD tracking device for quick installation, vehicle status, and trip monitoring.',
        features: ['OBD Plug-In', 'Fast Installation', 'Vehicle Status', 'Trip Monitoring'],
      },
      {
        model: 'VL863',
        name: 'VL863 Tracking Device',
        image: '/dts-assets/products/VL863.png',
        fallback: vehicleFallback,
        short:
          'Professional GPS tracking device for advanced vehicle monitoring, alerts, and fleet reports.',
        features: ['Advanced Tracking', 'Smart Alerts', 'Reports', 'Fleet Security'],
      },
    ],
  },
];

const ProductsPage = () => {
  useEffect(() => {
    document.title = 'Products | DTS - Dynamic Tracking Solutions';
  }, []);

  const handleImageError = (fallback) => (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = fallback;
  };

  return (
    <main className="products-page">
      <section className="products-page-hero">
        <div className="products-page-hero-overlay" />

        <div className="container products-page-hero-inner">
          <span className="products-page-label">
            <span />
            Products
          </span>

          <h1>
            DTS Tracking Devices
            <br />
            Product Showcase
          </h1>

          <p>
            Explore our professional GPS trackers and dashcam devices designed for
            fleet visibility, vehicle safety, live monitoring, alerts, and smarter
            business control.
          </p>

          <div className="products-hero-actions">
            <a href="#products-list" className="btn btn-primary">
              View Products
            </a>

            <a href="/contact-us" className="btn btn-outline hero-outline">
              Request Details
            </a>
          </div>

          <div className="products-hero-stats">
            <div>
              <strong>21+</strong>
              <span>Devices</span>
            </div>

            <div>
              <strong>JC</strong>
              <span>Dashcam Series</span>
            </div>

            <div>
              <strong>VG / VL</strong>
              <span>Tracking Series</span>
            </div>
          </div>
        </div>
      </section>

      <section className="products-intro-strip">
        <div className="container products-intro-grid">
          <div className="product-intro-card">
            <span>01</span>
            <h3>Real-Time Tracking</h3>
            <p>Monitor vehicles, routes, and trips with live location visibility.</p>
          </div>

          <div className="product-intro-card">
            <span>02</span>
            <h3>Smart Alerts</h3>
            <p>Get alerts for movement, ignition, geofence, theft, and safety events.</p>
          </div>

          <div className="product-intro-card">
            <span>03</span>
            <h3>Fleet Reports</h3>
            <p>Review trip history, driver activity, violations, and performance.</p>
          </div>

          <div className="product-intro-card">
            <span>04</span>
            <h3>Better Control</h3>
            <p>Improve vehicle security, reduce losses, and manage operations.</p>
          </div>
        </div>
      </section>

      <div id="products-list">
        {productsData.map((group) => (
          <section className="products-section" key={group.category}>
            <div className="container">
              <div className="section-header products-section-header reveal">
                <span className="section-label">{group.badge}</span>
                <h2>{group.category}</h2>
                <div className="divider" />
                <p>{group.description}</p>
              </div>

              <div className="products-grid">
                {group.products.map((product) => (
                  <article className="product-card reveal" key={product.model}>
                    <div className="product-image">
                      <img
                        src={product.image}
                        alt={`${product.model} ${product.name}`}
                        onError={handleImageError(product.fallback)}
                      />

                      <span>{product.model}</span>
                    </div>

                    <div className="product-content">
                      <small>DTS Product</small>
                      <h3>{product.name}</h3>
                      <p>{product.short}</p>

                      <ul>
                        {product.features.map((feature) => (
                          <li key={feature}>{feature}</li>
                        ))}
                      </ul>

                      <a href="/contact-us" className="product-link">
                        Get Details
                      </a>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        ))}
      </div>

      <section className="products-final-cta">
        <div className="container">
          <div className="products-cta-box reveal">
            <div>
              <span className="products-page-label cta-label">
                <span />
                Need Assistance?
              </span>

              <h2>Not sure which device is best for your fleet?</h2>

              <p>
                Contact DTS and our team will suggest the right tracking device,
                dashcam solution, and package according to your business needs.
              </p>
            </div>

            <a href="/contact-us" className="btn btn-primary">
              Talk to DTS Team
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProductsPage;